<template lang="html">
  <div class="eitia" @click.self="reselectShow = false">
    <div class="header">
      <!-- <img class="logo" src="@/assets/image/eitia/logo.png" alt=""> -->
      <div class="activityTime">
        2024.3.1～3.2 共襄盛会
      </div>
      <img class="hint" src="@/assets/image/eitiaSignIn/img1.png" alt="">
    </div>

    <div class="eitiaCon">
      <!-- 基本信息 -->
      <div class="basicInfo">
        <p class="conHint">参会信息*</p>
        <div class="userInfo cover">
          <input placeholder="请输入您的姓名" name="infoInput" class="infoInput" type="text" maxlength="10" v-model="userName">
        </div>

        <div class="userInfo userInfoPhone">
          <DiallingCodeSelection v-model="diallingCode" />
          <input placeholder="请输入您的电话" name="infoInput" class="infoInput" type="text" @input="handleInputChange" v-model="userPhone">
        </div>

        <div class="userInfo code">
          <input placeholder="请输入您的验证码" name="infoInput" class="infoInput codeInput" type="text" v-model="code">
          <div class="getCode" :class="{checkValid: codeEnabled}" @click="debouncedGetSmsCode">{{buttonMsg}}</div>
        </div>

        <div class="userInfo company">
          <textarea placeholder="请输入您的公司名称" name="infoInput" class="infoInput" maxlength="40" v-model='companyName' />
        </div>

        <div class="userInfo">
          <input placeholder="请输入您的职位" name="infoInput" class="infoInput" type="text" v-model="position">
        </div>

        <div class="userInfo">
          <input placeholder="请输入您的邮箱" name="infoInput" class="infoInput" type="text" v-model="mailbox">
        </div>
      </div>

      <!-- 会议时间 -->
      <div class="meetingTime">
        <p class="conHint">预参加会务(多选)*</p>

        <ul class="timeList">
          <li class="timeCon" v-for="(c, index) in meetingData" :key="index" :class="{timeConElse: meetingArr.includes(c.id)}" @click="checkedBox(c.id)">
            <div class="timeA" :class="{checked: meetingArr.includes(c.id)}">
              <span>{{c.meeting}}</span>
            </div>
          </li>
        </ul>
      </div>

      <!-- 其他诉求 -->
      <div class="elseDemand">
        <p class="conHint">备注</p>

        <div class="">
          <textarea placeholder="备注" name="userLocation" class="userLocation" maxlength="50" v-model='location' />
        </div>
      </div>

      <!-- 提交按钮 -->
      <div class="submitBtn" :class="{submitBtnElse: submitEnabled}" @click="debouncedGetSubmit">
        提交
      </div>

      <div class="agreementCon">
        <img src="@/assets/image/eitiaSignIn/icon5.png" alt="" v-show="checkboxValue == 0" @click="checkboxValue = 1">
        <img src="@/assets/image/eitiaSignIn/icon6.png" alt="" v-show="checkboxValue == 1" @click="checkboxValue = 0">
        <div>
          <p>已阅读并同意 <span class="link" @click="linkOutTo(pagebase + '/h5/agreement/elecomPrivacyPolicy.html')">《电巢隐私政策》</span>和<span class="link" @click="linkOutTo(pagebase + '/h5/agreement/elecomServeAgreement.html')">《电巢服务协议》</span></p>
        </div>
      </div>

      <p class="footerHint">组 委 会 咨 询 电 话</p>
      <div class="footerPhone">
        <div class="contactNumber" @click="dialPhoneNumber(phoneNumber)">
          <p>{{phoneNumber}}</p>
        </div>
        <div class="contactNumber" @click="dialPhoneNumber(phoneNumberEles)">
          <p>{{phoneNumberEles}}</p>
        </div>
      </div>
    </div>


    <div v-show="hintShow" class="hintMod" :class="{hintModElse: hintModElseType}">
      <p>{{hintCon}}</p>
    </div>

    <div class="popUpNo1" v-show="succeedShow">
      <div class="conPopUpNo1">
        <img src="@/assets/image/eitiaSignIn/icon3.png" alt="" class="succeedImg">
        <h4>大会报名成功！</h4>
        <p>诚挚邀请您在大会开始时，莅临EITIA大会的线上元宇宙世界，与我们一同共襄盛会！</p>
        <div class="conferenceTime">
          <img src="@/assets/image/eitiaSignIn/icon4.png" alt="">
          大会时间：
          <span> 2024年03月01日 </span>
        </div>
        <img src="@/assets/image/eitiaSignIn/img2.png" alt="" class="succeedImgMa">
        <div class="hint">
          您可<span>长按保存二维码</span>在大会开始时扫码进入EITIA大会的元宇宙世界
        </div>
        <div class="btn" @click="getEcosmos">进入元宇宙</div>
        <p class="experienceHint experienceHintNo1" @click="copeText">您也可以使用电脑版Chrome浏览器打开 <br> <span>https://ecosmos.elecnest.com/</span> <br> 已获得更好的观看体验</p>
      </div>
    </div>

    <div class="popUpNo2" v-show="succeedShow2">
      <div class="conPopUpNo2">
        <h4>报名成功</h4>
        <p>您已提交过预约信息，若要修改信息，请修改过后重新提交～</p>
        <div @click="succeedShow2 = false">我知道了</div>
      </div>
    </div>

    <div class="popUpNo3" v-show="succeedShow3">
      <div class="conPopUpNo3">
        <h4>报名成功</h4>
        <p>您已提交过预约信息，若要修改信息，请修改过后重新提交～</p>
        <div>
          <p class="popUpCloseNo3" @click="succeedShow3 = false">关闭</p>
          <p class="popUpAmendNo3" @click="getBackfill">确定修改</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/utils'
  import Cookies from 'js-cookie';
  import WxShare from '@/utils/wxshare';
  import { pagebase } from '@/utils/http.js';
  import DiallingCodeSelection from '../DiallingCodeSelection'
  // 防抖
  import { debounce } from 'lodash';

  var word = /^([\u4E00-\u9FA5]+|[a-zA-Z]+)+$/;
  var phone = /^1[3456789]\d{9}$/;
  var unmber = /^[0-9]+$/;
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  export default {
    components: {
      DiallingCodeSelection: DiallingCodeSelection
    },

    data() {
      return {
        eitiaType: this.$route.query.type || 0,
        pagebase: pagebase,
        show: false,

        diallingCode: '86',
        limitTime: 60,
        buttonMsg: '获取验证码',
        codeEnabled: false,
        userName: '',
        userPhone: '',
        code: '',
        companyName: '',
        position: '',
        mailbox: '',
        location: '',
        meetingData: [{
            meeting: 'AI行业趋势及硬件挑战 (3月1日)',
            id: 1,
          },
          {
            meeting: '互连硬件及工程技术创新 (3月2日)',
            id: 2,
          },
        ],
        meetingArr: [],
        isStay: 0,
        stayDescribe: '',
        reselectType: 0,
        stayShow: false,
        reselectShow: false,
        stayType: 1,
        stayTypeShow: false,
        popUpSelectShow: true,
        houseCur: 0,
        timeCur: 1,
        houseText: '',
        showTime: '',
        startTime: '',
        endTime: '',
        repastData: [{
            repast: '早餐 3.1',
            id: 1,
            time: ""
          },
          {
            repast: '早餐 3.2',
            id: 2,
          },
        ],
        repastArr: [],
        phoneNumber: '13823761402',
        phoneNumberEles: '18566271170',
        hintShow: false,
        hintTime: 1,
        hintCon: '',

        succeedShow: false,
        succeedShow2: false,
        succeedShow3: false,

        userHouse: ['大床房', '双床房'],
        onChangeIndex: 1,
        userHouseTime: ['02月29日-03月01日', '03月01日-03月02日', '02月29日-03月02日'],
        userHouseTimeIndex: 1,

        attendMeetings: '',
        checkboxValue: 0,
        hintModElseType: 0,
      }
    },

    computed: {
      submitEnabled() {
        return this.userName && this.userPhone && this.code && this.companyName && this.position && this.mailbox && this.meetingArr.length && this.checkboxValue
      },
      confereeInfo() {
        return word.test(this.userName) && this.userPhone && this.code && this.companyName && this.position && emailRegex.test(this.mailbox) && this.checkboxValue
      }
    },

    mounted() {
      document.title = 'EITIA电子互连技术创新大会';
      if (Cookies.get('userPhone')) {
        this.getBackfill()
        
        this.codeEnabled = true;
      }
      
      this.init()
    },

    methods: {
      init(){
        // 微信分享
        this.wxshare = new WxShare();
        
        this.wxshare.share({
          title: '2024电子互连技术创新大会',
          desc: '邀您赴约，共襄盛举',
          link: window.location.href,
          imgUrl: pagebase + '/static/img/vx/eitia.png',
        })
      },
      
      // 监听验证手机号
      handleInputChange(e) {
        if (phone.test(this.userPhone)) {
          let value = e.target.value
          this.codeEnabled = utils.checkPhone(value)

          this.$http({
            url: '/meet/getMeetUserInfo',
            method: 'get',
            params: {
              phone: this.userPhone,
              type: '2',
            },
          }).then((res) => {
            if (res.code >= 0) {
              this.succeedShow3 = true
            }
          })
        } else {
          return;
        }
      },

      // 获取验证码
      getSmsCode() {
        if (this.userPhone != '') {
          if (this.limitTime == 60) {
            this.$http.get('/Registered/getPhoneSmsCode', {
              params: utils.cso({
                phone: this.userPhone,
                phone_head: this.diallingCode,
                type: 10,
                client: 'H5'
              })
            }).then((res) => {
              if (res.code >= 0) {
                this.buttonMsg = this.limitTime + 's后重试'
                this.timer = window.setInterval(() => {
                  this.limitTime--
                  this.buttonMsg = this.limitTime + 's后重试'
                  if (this.limitTime < 0) {
                    window.clearInterval(this.timer)
                    this.buttonMsg = '获取验证码'
                    this.limitTime = 60
                  }
                }, 1000)
              } else {
                this.setHintCon(res.msg);
              }
            })
          } else {
            this.setHintCon("短信已经发送,5分钟内请勿重复点击");
          }
        }
      },

      // 获取参会时间
      checkedBox(i) {
        if (this.meetingArr.includes(i)) {
          this.meetingArr = this.meetingArr.filter(function(ele) {
            return ele != i;
          });
        } else {
          this.meetingArr.push(i);
        }
      },

      // 用餐信息
      getCateringInfo(i) {
        if (this.repastArr.includes(i)) {
          this.repastArr = this.repastArr.filter(function(ele) {
            return ele != i;
          });
        } else {
          this.repastArr.push(i);
        }
      },

      getSubmit() {
        // 姓名
        if (word.test(this.userName) && this.userName) {
          // 电话
          if (this.userPhone) {
            // 验证码
            if (unmber.test(this.code) && this.code) {
              // 公司名称
              if (this.companyName) {
                // 职位
                if (this.position) {
                  // 邮箱
                  if(emailRegex.test(this.mailbox) && this.mailbox) {
                    // 会务
                    if (this.meetingArr.length >= 1) {
                      // 协议
                      if (this.checkboxValue == 1) {
                        this.$http({
                          url: '/meet/addMeetUserInfo',
                          method: 'post',
                          params: {
                            username: this.userName,
                            phone: this.userPhone,
                            sms_code: this.code,
                            unit: this.companyName,
                            position: this.position,
                            email: this.mailbox,
                            // docking_people: this.elePeople,
                            want_meeting: this.meetingArr.join(','),
                            other_claims: this.location,
                            // type: '2',
                            channel_id: this.$route.query.channel,
                            phone_head: this.diallingCode,
                          },
                        }).then((res) => {
                          if (res.code >= 0) {
                            Cookies.set('userPhone', this.userPhone, {
                              expires: 7,
                            });
                            Cookies.set('timeCur', this.timeCur, {
                              expires: 7,
                            });

                            if (Math.min(...this.meetingArr) < 2) {
                              this.attendMeetings = '3月1日'
                            } else {
                              this.attendMeetings = '3月2日'
                            }

                            this.code = ''
                            this.succeedShow = true;
                          } else {
                            if (res.code == -11) {
                              window.scrollTo(0, 0);
                              this.setHintCon(res.msg)
                            } else {
                              this.setHintCon(res.msg)
                            }
                          }
                        })
                      } else {
                        this.setHintCon('请勾选服务协议后再提交')
                        window.scrollTo(0, 500);
                      }
                    } else {
                      this.setHintCon('请选择您需参加的会务')
                      window.scrollTo(0, 400);
                    }
                  } else {
                    if (this.elePeople != '') {
                      this.setHintCon('邮箱输入有误，请检查')
                    } else {
                      this.setHintCon('请输入您的邮箱')
                    }
                    window.scrollTo(0, 100);
                  }
                } else {
                  if (this.position != '') {
                    this.setHintCon('职位有误，请检查')
                  } else {
                    this.setHintCon('请输入您的职位')
                  }
                  window.scrollTo(0, 100);
                }
              } else {
                if (this.companyName != '') {
                  this.setHintCon('公司名称有误，请检查')
                } else {
                  this.setHintCon('请输入公司名称')
                }
                window.scrollTo(0, 100);
              }
            } else {
              this.setHintCon('请输入验证码')
              window.scrollTo(0, 100)
            }
          } else {
            if (this.userPhone != '') {
              this.setHintCon('电话有误，请检查')
            } else {
              this.setHintCon('请输入您的电话')
            }
            window.scrollTo(0, 100);
          }
        } else {
          if (this.userName != '') {
            this.setHintCon('姓名有误，请检查')
          } else {
            this.setHintCon('请输入您的姓名')
          }
          window.scrollTo(0, 0);
        }
      },

      getEcosmos(){
        this.succeedShow = false;
        window.location.href = 'https://ecosmos.elecnest.com/';
      },

      linkOutTo(url) {
        window.location.href = url
      },

      dialPhoneNumber() {
        window.location.href = `tel:${this.phoneNumber}`;
      },

      setHintCon(e) {
        window.clearInterval(this.timers)
        this.hintCon = e;
        this.hintShow = true;
        this.timers = window.setInterval(() => {
          this.hintTime--
          if (this.hintTime < 0) {
            window.clearInterval(this.timers)
            this.hintShow = false
            this.hintTime = 1
          }
        }, 1000)
      },

      // 回填用户信息
      getBackfill() {
        this.succeedShow3 = false

        this.$http({
          url: '/meet/getMeetUserInfo',
          method: 'get',
          params: {
            phone: this.userPhone || Cookies.get('userPhone'),
            type: '2',
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.userName = res.data.username
            this.userPhone = res.data.phone
            this.companyName = res.data.unit
            this.position = res.data.position
            this.elePeople = res.data.docking_people
            this.mailbox = res.data.email

            let vueArray = res.data.want_meeting.split(",")
            this.meetingArr = vueArray.map(item => parseFloat(item));

            if (res.data.is_stay == 1) {
              this.isStay = 1;
              this.timeCur = Cookies.get('timeCur')

              this.startTime = new Date(res.data.checkin_time * 1000)
              this.endTime = new Date(res.data.checkout_time * 1000)

              if (res.data.bed == 1) {
                this.houseCur = 1
                this.timeCur = 1
                this.stayDescribe = '大床房 ' + (this.startTime.getMonth() + 1) + '.' + (this.startTime.getDate()) + '日-' + (this.endTime.getMonth() + 1) + '.' + (this.endTime.getDate()) + '日'
              } else {
                this.houseCur = 2
                this.timeCur = 1
                this.stayDescribe = '双床房 ' + (this.startTime.getMonth() + 1) + '.' + (this.startTime.getDate()) + '日-' + (this.endTime.getMonth() + 1) + '.' + (this.endTime.getDate()) + '日'
              }

              this.stayShow = true;
            } else if (res.data.is_stay == 2) {
              this.isStay = 2;
              this.stayDescribe = '无需住宿';
              this.stayShow = true;
            }

            let vueElseArray = res.data.conference_catering.split(",")
            this.repastArr = vueElseArray.map(item => parseFloat(item));
          }
        })
      },

      onChange(picker, value, index) {
        this.onChangeIndex = index
        if (index == 0) {
          this.houseCur = 1
        } else {
          this.houseCur = 2
        }
      },

      onChangeElse(picker, value, index) {
        this.onChangeIndex = index
        if (index == 0) {
          this.timeCur = 1
        } else if (index == 1) {
          this.timeCur = 2
        } else {
          this.timeCur = 3
        }
      },

      copeText(){
        const input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value', 'https://ecosmos.elecnest.com/')
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
        }
        document.body.removeChild(input)
        this.hintModElseType = 1;
        this.setHintCon('复制成功')
      },

      debouncedGetSmsCode: debounce(function(){
        this.getSmsCode()
      }, 500),

      debouncedGetSubmit: debounce(function(){
        this.getSubmit()
      }, 500),
    }
  }
</script>

<style lang="css" scoped>
  .eitia {
    box-sizing: border-box;
    width: 100%;
    height: auto;
    padding-bottom: 3rem;
    background: linear-gradient(#0F003A, #16228F, #033363);
  }

  .conHint {
    box-sizing: border-box;
    font-size: 1.6rem;
    color: #00FEFF;
  }

  .conHint span {
    font-size: 1.2rem;
    color: #CCCCCC;
  }

  /* 头部基础信息 */
  .header {
    box-sizing: border-box;
    width: 100%;
    height: 29.4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url('~@/assets/image/eitiaSignIn/back7.png');
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 12.5rem;
  }

  .logo {
    width: 24.2rem;
    margin-top: 4.5rem;
  }

  .activityTime {
    width: 22.1rem;
    height: 2.6rem;
    background-image: url('~@/assets/image/eitia/back2.png');
    background-repeat: no-repeat;
    background-size: contain;
    font-size: 1.4rem;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
  }

  .hint {
    width: 18.6rem;
    height: 2.1rem;
    margin-top: 1.8rem;
  }

  .eitiaCon {
    box-sizing: border-box;
    padding: 0 2rem;
    margin-top: -6rem;
  }

  /* 基本信息 */
  .basicInfo {
    box-sizing: border-box;
    width: 100%;
    margin-top: 1.05rem;
  }

  .userInfo {
    box-sizing: border-box;
    width: 100%;
    height: 4.7rem;
    margin-top: 1.5rem;
    padding: 1.3rem 1.5rem;
    background-image: url('~@/assets/image/eitiaSignIn/back8.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-color: rgba(0, 0, 0, 0.25);
    /* backdrop-filter: blur(7px); */
    border-radius: 1.4rem .6rem 1.2rem .6rem;
  }

  .userInfoPhone {
    display: flex;
  }

  .company {
    height: 6.8rem;
    padding: 0;
    background-image: url('~@/assets/image/eitiaSignIn/back9.png');
    background-size: 100% 100%;
    font-family: -webkit-body;
    resize: none;
    outline: none;
    overflow: hidden;
  }

  .company textarea {
    width: 100% !important;
    height: 100% !important;
    padding: 1.3rem 1.5rem;
    box-sizing: border-box;
  }

  .cover {
    margin-top: 1.15rem;
  }

  .code {
    display: flex;
    justify-content: space-between;
  }

  .infoInput {
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: none;
    outline: none;
    color: #00FEFF;
    font-size: 1.5rem;
  }

  .infoInput[name="infoInput"]::-webkit-input-placeholder {
    color: #73A9A9;
  }

  .codeInput {
    width: 70%;
  }

  .getCode {
    width: 7.5rem;
    font-size: 1.4rem;
    color: #6AB2B3;
    text-align: end;
  }

  .checkValid {
    color: #00FEFF;
  }

  /* 会议时间 */
  .meetingTime {
    box-sizing: border-box;
    width: 100%;
    margin-top: 2rem;
  }

  .timeList {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    list-style: none;
    padding-top: 1.2rem;
  }

  .timeCon {
    box-sizing: border-box;
    margin-bottom: 2rem;
    width: 100%;
    height: 5.2rem;
    background-image: url('~@/assets/image/eitiaSignIn/back8.png');
    background-size: 100% 100% ;
    background-repeat: no-repeat;
    background-color: rgba(0, 0, 0, 0.25);
    /* backdrop-filter: blur(7px); */
    border-radius: 1.6rem 0 1.2rem 0;
    display: flex;
    align-items: center;
  }

  .timeConElse {
    background-color: rgba(0, 211, 255, 0.34);
  }

  .timeA {
    box-sizing: border-box;
    padding: 0 1.3rem;
    color: #00FEFF;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
  }

  .timeA:before {
    width: 1.8rem;
    height: 1.8rem;
    line-height: 10px;
    content: "";
    border: 1px #000 solid;
    margin-right: 2px;
    transition: all 0.3s linear;
    border: none;
    background-image: url('~@/assets/image/eitia/icon7.png');
    background-size: cover;
  }

  .timeA span {
    margin-left: .5rem;
  }

  .checked {
    color: #FFFFFF;
  }

  .checked:before {
    background-image: url('~@/assets/image/eitia/icon8.png');
  }

  /* 预约住宿 */
  .stay {
    box-sizing: border-box;
  }

  .stayCon {
    box-sizing: border-box;
    padding: 0 1.5rem;
    width: 100%;
    height: 5.2rem;
    background-color: rgba(0, 0, 0, 0.25);
    /* backdrop-filter: blur(7px); */
    margin-top: 1.15rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(to right, #2A39DA, #00B0EE);
    border-radius: .6rem;
    border: .05rem solid #33FFD3;
  }

  .stayConCover {
    background: linear-gradient(to right, #005CFB, #00FFC5);
  }

  .stayDescribe {
    font-size: 1.5rem;
    color: #FFFFFF;
  }

  .reselectNo1 {
    width: 100%;
    height: 98%;
    font-size: 1.4rem;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .reselectNo1 p {
    width: 49.5%;
    height: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .reselect {
    width: 7.5rem;
    font-size: 1.4rem;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: end;
  }

  .reselect img {
    width: auto;
    height: 1rem;
    margin-left: .5rem;
    margin-top: .1rem;
  }

  /* 住宿类型弹框 */
  .van-overlay {
    background: none;
    bottom: 0;
  }

  .stayPopUp {
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #FFFFFF;
    width: 100%;
    border-radius: 2rem 2rem 0 0;
    z-index: 99;
  }

  .popUpHeader {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 2.3rem 2rem;
    border-bottom: .05rem solid #EBEBEB;
  }

  .popUpHeader img {
    width: 1.6rem;
    height: 1.6rem;
  }

  .popUpHint {
    width: 7rem;
    font-size: 1.8rem;
    margin-right: 10.5rem;
    color: #333333;
    font-weight: 600;
  }

  .stayType {
    box-sizing: border-box;
    height: 18rem;
    padding: 0 1.5rem;
    padding-top: 4rem;
  }

  .stayType p {
    width: 100%;
    height: 5rem;
    line-height: 5rem;
    text-align: center;
    color: rgba(51, 51, 51, 0.60);

  }

  .stayCoverType {
    color: #178EA3 !important;
    background-color: #E5F6F9;
  }

  .popUpSelect {
    display: flex;
    justify-content: center;
    margin-top: 3rem;
  }

  .houseType {
    box-sizing: border-box;
    margin-right: 5.1rem;
    font-size: 1.6rem;
    color: rgba(51, 51, 51, 0.7);
  }

  .van-picker__columns {
    max-height: 10rem;
  }

  .houseType p {
    margin-bottom: 2.75rem;
  }

  .selectHouse {
    color: rgba(23, 142, 163, 1);
  }

  .houseTime {
    box-sizing: border-box;
    margin-left: 5.1rem;
    font-size: 1.6rem;
    color: rgba(51, 51, 51, 0.7);
  }

  .houseTime p {
    margin-bottom: 2.75rem;
  }

  .confirmBtn {
    width: 21.7rem;
    height: 4.4rem;
    line-height: 4.4rem;
    text-align: center;
    color: #FFFFFF;
    border-radius: 4.4rem;
    background-color: #178EA3;
    margin-left: 7.5rem;
    margin-bottom: 5rem;
  }

  .selectTime {
    color: rgba(23, 142, 163, 1);
  }

  /* 其他诉求 */
  .userLocation {
    background-image: url('~@/assets/image/eitiaSignIn/back9.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-color: rgba(0, 0, 0, 0.25);
    /* backdrop-filter: blur(7px); */
    border-radius: 1.6rem 0 1.2rem 0;
    box-sizing: border-box;
    border: none;
    padding: 1.5rem;
    color: #333333;
    font-size: 1.5rem;
    width: 100%;
    height: 9.2rem;
    margin-top: 1rem;
    font-family: -webkit-body;
    resize: none;
    outline: none;
    color: #00FEFF;
  }

  .userLocation[name="userLocation"]::-webkit-input-placeholder {
    color: #6AB2B3;
  }

  /* 提交按钮 */
  .submitBtn {
    width: 100%;
    height: 4.9rem;
    background-color: hsla(209, 100%, 50%, 0.7);
    color: rgba(255, 255, 255, 0.55);
    font-size: 1.7rem;
    line-height: 4.9rem;
    text-align: center;
    margin-top: 1.2rem;
    border-radius: .5rem;
  }

  .submitBtnElse {
    color: #FFFFFF;
    background-color: #0083FF;
  }

  /* 协议 */
  .agreementCon {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    color: #FFFFFF;
  }

  .agreementCon img {
    width: 1.45rem;
    height: 1.45rem;
    margin-right: .5rem;
  }

  .agreementCon span {
    color: #00FEFF;
  }

  .footerHint {
    font-size: 1.5rem;
    color: #71FEFF;
    text-align: center;
    margin-top: 3rem;
  }

  .footerPhone {
    display: flex;
    justify-content: center;
  }

  .contactNumber {
    display: flex;
    align-items: center;
    font-size: 1.5rem;
    color: #71FEFF;
    margin: 0 1rem;
    margin-top: .5rem;
  }

  .contactNumber div {
    margin-right: .5rem;
  }
  
  .contactNumber p {
    border-bottom: 1px solid #71FEFF;
  }

  /* 提示 */
  .hintMod {
    box-sizing: border-box;
    position: fixed;
    bottom: 45%;
    left: 0;
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: 99999;
  }

  .hintMod p {
    box-sizing: border-box;
    padding: 0 1.5rem;
    background-color: rgba(255, 255, 255, 1);
    font-size: 1.3rem;
    color: #000000;
    max-width: 65%;
    height: 4rem;
    border-radius: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .hintModElse p{
    background-color: rgba(0, 0, 0, 0.60);
    color: #FFFFFF;
  }

  /* 提示框 1 */
  .popUpNo1 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.50);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .conPopUpNo1 {
    box-sizing: border-box;
    width: 31.8rem;
    height: 57.9rem;
    padding: 0 2rem;
    border-radius: .5rem;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    
  }

  .succeedImg {
    width: 3.4rem;
    height: 3.4rem;
    margin-top: 2.3rem;
  }

  .succeedImgMa {
    width: 23.2rem;
    height: 23.2rem;
    margin-top: 1.15rem;
  }

  .conPopUpNo1 h4 {
    font-size: 1.8rem;
    margin-top: .65rem;
  }

  .conPopUpNo1 p {
    margin-top: .85rem;
    font-size: 1.4rem;
  }

  .conPopUpNo1 > .hint {
    width: 100%;
    font-size: 1.2rem;
    text-align: center;
    color: #777777;
    margin-top: 1.1rem;
    height: auto;
  }

  .conPopUpNo1 > .hint span {
    color: #0083FF;
  }

  .conferenceTime {
    display: flex;
    align-items: center;
    font-size: 1.4rem;
    margin-top: .85rem;
  }

  .conferenceTime img {
    width: 1.65rem;
    height: 1.65rem;
    margin-top: .2rem;
    margin-right: .3rem;
  }

  .conferenceTime span {
    font-size: 1.5rem;
    font-weight: 600;
    border-bottom: .1rem solid #000;
  }

  .conPopUpNo1 .btn {
    background-color: #0083FF;
    color: #FFFFFF;
    width: 21.5rem;
    height: 4.4rem;
    border-radius: 4.4rem;
    line-height: 4.4rem;
    text-align: center;
    margin-top: .95rem;
  }

  /* 提示框 2 */
  .popUpNo2 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.50);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .conPopUpNo2 {
    box-sizing: border-box;
    padding: 0 3rem;
    width: 30rem;
    height: 19rem;
    border-radius: .5rem;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .conPopUpNo2 h4 {
    font-size: 1.8rem;
    margin-top: 2.5rem;
  }

  .conPopUpNo2 p {
    margin-top: 2rem;
    font-size: 1.5rem;
  }

  .conPopUpNo2 div {
    background-color: #178EA3;
    color: #FFFFFF;
    width: 12rem;
    height: 4.4rem;
    border-radius: 4.4rem;
    line-height: 4.4rem;
    text-align: center;
    margin-top: 1.4rem;
  }

  /* 提示框 3 */
  .popUpNo3 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.50);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .conPopUpNo3 {
    box-sizing: border-box;
    padding: 0 3rem;
    width: 30rem;
    height: 19rem;
    border-radius: .5rem;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .conPopUpNo3 h4 {
    font-size: 1.8rem;
    margin-top: 2.5rem;
  }

  .conPopUpNo3 p {
    margin-top: 2rem;
    font-size: 1.5rem;
  }

  .conPopUpNo3 div {
    display: flex;
  }

  .popUpCloseNo3 {
    background-color: #F5F5F5;
    color: #333333;
    width: 12rem;
    height: 4.4rem;
    border-radius: 4.4rem;
    line-height: 4.4rem;
    text-align: center;
    margin-top: 1.4rem;
    margin-right: .5rem;
  }

  .popUpAmendNo3 {
    background-color: #2A3CD7;
    color: #FFFFFF;
    width: 12rem;
    height: 4.4rem;
    border-radius: 4.4rem;
    line-height: 4.4rem;
    text-align: center;
    margin-top: 1.4rem;
  }

  .experienceHint {
    font-size: 1.2rem;
    text-align: center;
    margin-top: 1rem;
  }

  .experienceHint span {
    color: #00B0EE;
    border-bottom: .1rem solid #00B0EE;
  }

  .experienceHintNo1 {
    font-size: 1.2rem !important;
  }
</style>